import React from "react";
import Cocktail from "./Cocktail";
import Loading from "./Loading";
import { useGlobalContext } from "../context";

const CocktailList = () => {
  const { cocktaildatalist } = useGlobalContext();
  if (!cocktaildatalist) {
    return <Loading></Loading>;
  }
  return (
    <div className="cocktails-center">
      {cocktaildatalist === undefined && <Loading></Loading>}
      {cocktaildatalist.drinks.map((cocktail) => {
        return <Cocktail cocktail={cocktail} key={cocktail.idDrink}></Cocktail>;
      })}
    </div>
  );
};

export default CocktailList;
